import { lazy } from 'react';
import reducer from './state/reducers';
import { getStore } from '@AppRedux/store';
import checkAuth from '@Utils/checkAuth';

const store = getStore();

const TrainingMasterModuleList = lazy(() =>
    import('./TrainingMasterModuleList').then(async module => {
        await checkAuth();
        const auth = getStore().getState().auth;
        if(auth.isAuthenticated) {
            store.injectReducer('trainingMasterModuleList', reducer.listReducer);
            return module;
        }
    })
);

const TrainingMasterModuleRoutes = [
    {
        label: 'Training Master Module',
        path: '/HRAutomation/TrainingMasterModule',
        menuName: 'hrAutomation',
        component: TrainingMasterModuleList,
        icon: 'fa-list',
        exact: true,
        showNav: true, 
        public: true, 
    },
]

export default TrainingMasterModuleRoutes;